import GraphObject, { type GraphObjectProps } from './object'

import 'components/graph/node.less'

type NodeProps = Omit<GraphObjectProps, 'objectType' | 'objectAttrs' | 'showMetaDepth'> & Record<string, unknown>

const NODE_ATTRS = ['neighbors']

const Node = (props: NodeProps) => (
  <GraphObject {...props} objectType="node" objectAttrs={NODE_ATTRS} />
)

export default Node
